import { Component, AfterViewInit, OnInit, HostListener } from '@angular/core';

import { OralDeposition } from '../../../models/oral-deposition';

import { NotyService } from '../../../services/common/noty.service';
import { OralDepositionService } from '../../../services/oral_depositions/oral-deposition.service';

declare var jQuery: any;
declare var moment: any;

@Component({
  selector: 'app-oral-deposition-index',
  templateUrl: './oral-deposition-index.component.html',
  styleUrls: ['./oral-deposition-index.component.scss'],
})
export class OralDepositionIndexComponent implements OnInit {
  count: number = 0;

  dateResult: string;

  oralDepositions: Array<OralDeposition> = [];

  search_options: any = {
    per_page: 20,
    in_order_of: [],
    ordered_by: [],
    statuses: [],
  };

  search_params: any = {
    page: 1,
    per_page: 20,
  };

  searching: boolean = true;

  constructor(private notyService: NotyService, private oralDepositionService: OralDepositionService) {}

  // Component lifecycle methods
  ngOnInit() {
    let scope: OralDepositionIndexComponent = this;
    var start = moment().subtract(30, 'days');
    var end = moment();
    this.dateResult = `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`;
    this.search_params.start_date = start.format('YYYY-MM-DD');
    this.search_params.end_date = end.format('YYYY-MM-DD');
    if (jQuery('#date-range-search').data('daterangepicker')) jQuery('#date-range-search').data('daterangepicker').remove();
    jQuery('#date-range-search').daterangepicker(
      {
        opens: 'left',
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          'Last 30 Days': [moment().subtract(30, 'days'), moment()],
          'Last 60 Days': [moment().subtract(60, 'days'), moment()],
          'Last 90 Days': [moment().subtract(90, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
      },
      (start: any, end: any) => {
        scope.dateResult = `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`;
        scope.search_params.start_date = start.format('YYYY-MM-DD');
        scope.search_params.end_date = end.format('YYYY-MM-DD');
      }
    );
    this.oralDepositionService.searchOptions().then((search_options) => {
      this.search_options = search_options;
      this.search_params.in_order_of = this.search_options.default_options.in_order_of;
      this.search_params.ordered_by = this.search_options.default_options.ordered_by;
      this.search_params.per_page = this.search_options.default_options.per_page;
      this.search_params.status = this.search_options.default_options.status;
      this.search();
    });
  }

  ngAfterViewInit() {
    this.setInitialSidebarPosition();
  }

  // Event Listeners

  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  //Component methods
  clearSearch() {
    var start = moment().subtract(30, 'days');
    var end = moment();
    this.dateResult = `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`;
    this.search_params.start_date = start.format('YYYY-MM-DD');
    this.search_params.end_date = end.format('YYYY-MM-DD');
    this.search_params.in_order_of = this.search_options.default_options.in_order_of;
    this.search_params.ordered_by = this.search_options.default_options.ordered_by;
    this.search_params.per_page = this.search_options.default_options.per_page;
    this.search_params.status = this.search_options.default_options.status;
    this.search_params.page = 1;
    jQuery('#date-range-search')
      .data('daterangepicker')
      .setStartDate(`${start.format('MM/DD/YYYY')}`);
    jQuery('#date-range-search')
      .data('daterangepicker')
      .setEndDate(`${end.format('MM/DD/YYYY')}`);
    this.search();
  }

  search(pageNumber: any = null) {
    if (pageNumber) this.search_params.page = pageNumber.page;
    this.searching = true;
    this.oralDepositionService
      .index(this.search_params)
      .then((response_json) => {
        this.searching = false;
        this.count = response_json.count;
        this.oralDepositions = response_json.oral_depositions;
      })
      .catch(() => {
        this.searching = false;
      });
  }

  // Functions for UI manipulation using vanilla JS or jQuery

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 10 + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 40;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 40;
        //console.log('lesser ' + matter_sidebar.style.top);
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 81;
      if (search_height > 0) content_search.style.height = search_height + 'px';
      else content_search.style.height = '0px';
    }
  }

  setInitialSidebarPosition() {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
    let sidebar_position = () => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    };
    for (var i = 1; i < 20; i += 1) setTimeout(sidebar_position, (i * 1000) / 2);
  }
}
